import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { withUserType } from '../withUserType';

class AdminCycleEventsPage extends React.Component<any, null> {
	render() {
		const { userType } = this.props;
		return (
			<div>
				<Route
					path={`/${userType}/admin/cycleevents`}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/${userType}/admin/cycleevents/overview`,
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}

export default withUserType(AdminCycleEventsPage);
